import { ButtonV2, Flex, styled, TextV2 } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { BANK_PARTNER_PROMO_FONT_FAMILY } from './constants';

export const transferDialogOverrides = {
  Content: {
    props: {
      width: pxToRem(480),
      maxWidth: '100%',
    },
  },
};

export const TransferDialogBody = styled(Flex)`
  flex-direction: column;
  background: white;
  min-height: 100%;
`;

export const AllyPromoHeadline = styled(TextV2)`
  font-size: ${pxToRem(26)};
  font-weight: 700;
  font-family: ${BANK_PARTNER_PROMO_FONT_FAMILY};
  color: #1a1a1a;
  line-height: 1.25;
  letter-spacing: -0.5px;
`;

export const AllyPromoSubtext = styled(TextV2)`
  font-size: ${pxToRem(13)};
  font-family: ${BANK_PARTNER_PROMO_FONT_FAMILY};
  color: #777;
  line-height: 1.7;
  font-weight: 400;
`;

export const AllyAmountDisplay = styled(TextV2)`
  font-size: ${pxToRem(70)};
  font-weight: 800;
  font-family: ${BANK_PARTNER_PROMO_FONT_FAMILY};
  letter-spacing: -3px;
  line-height: 1;
  margin-bottom: ${pxToRem(8)};
  transition: color 0.4s ease;
`;

export const AllyAmountSubtext = styled(TextV2)`
  font-size: ${pxToRem(13)};
  font-family: ${BANK_PARTNER_PROMO_FONT_FAMILY};
  color: #888;
  margin-bottom: ${pxToRem(32)};
  letter-spacing: 0.2px;
`;

export const AllyNudgeBar = styled(Flex)`
  background: #f2ede8;
  border-radius: ${pxToRem(12)};
  padding: ${pxToRem(14)} ${pxToRem(16)};
  margin-bottom: ${pxToRem(12)};
  text-align: left;
  flex-direction: column;
  gap: ${pxToRem(12)};
`;

export const AllyNudgeText = styled(TextV2)`
  font-size: ${pxToRem(13)};
  font-family: ${BANK_PARTNER_PROMO_FONT_FAMILY};
  color: #666;
  line-height: 1.6;
`;

export const AllyPrimaryButton = styled(ButtonV2)`
  width: 100%;
  margin-bottom: ${pxToRem(10)};
`;

export const AllySecondaryButton = styled(ButtonV2)`
  width: 100%;
  margin-bottom: ${pxToRem(24)};
  && {
    color: #aaa;
    border-color: #e8e8e8;
  }
  &&:hover {
    color: #777;
    border-color: #d0d0d0;
  }
`;

// Partner brand terms ("$200", "Ally") are intentionally not translated — they are fixed partner asset values.
export const AllyInlinePurple = styled.span`
  color: #6b2d8b;
  font-weight: 700;
`;

export const AllyFinePrint = styled(TextV2)`
  font-size: ${pxToRem(11)};
  font-family: ${BANK_PARTNER_PROMO_FONT_FAMILY};
  color: #aaa;
  line-height: 1.7;
`;
